import React from 'react';

import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import DropdownCOELs from "root/ReactHookForm/ui/DropdownCOELs";
import DropdownALDs from "root/ReactHookForm/ui/DropdownALDs";
import {FormSectionNames} from "root/s360components/LearningJournal/LearningJournalPage";

export const coelAndALD = () =>
{
    return {
        [FormSectionNames.COEL]:
            {
                coel: [{ value: 0 }], // Default to ALL
                ald: [{ value: 0 }],
            }
    }
}

const HookSubFormCoelAndALD = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const [ groupId ] = useWatchDropdown( {control, name: sectionName + '.' + 'eyfs_group_id', isInt: false, namedField: 'group_id' }) ;

    const validateCoel = (val) =>
    {
        if (val === null)
        {
            return "Please Select a CoEL.";
        }
    }

    const validateALD = (val) =>
    {
        if (val === null)
        {
            return "Please Select an ALD.";
        }
    }

    return (
        <S360WidgetBlock title='Coel and ALD Filtering'>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <DropdownCOELs name={sectionName + '.coel'} control={control} rules={{validate: validateCoel}}
                                                      placeHolder='CoEL' readOnly={false} isMulti={true}/>
                    <SmartErrorDiv sectionName={sectionName}  name={'coel'} formErrors={formErrors} />
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <DropdownALDs name={sectionName + '.ald'} control={control} rules={{validate: validateALD}}
                                                      placeHolder='ALD' readOnly={ false } isMulti={true} />
                    <SmartErrorDiv sectionName={sectionName}  name={'ald'} formErrors={formErrors} />
                </BootstrapCol>
            </BootstrapRow>
        </S360WidgetBlock>
    )
}


export default HookSubFormCoelAndALD;
